<template>
  <div class="pi-my-coupon">
    <div class="coupon-tabs">
      <div class="coupon-tabs-item"
           @click="tabClick(item.value)"
           :class="{ active: form.couponStatus == item.value }"
           v-for="(item, index) in tabsList"
           :key="index">
        {{ item.label }}
      </div>
    </div>
    <div class="coupon-list">
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
        <ul class="coupon-ul"
            v-if="form.couponStatus == 0">
          <pi-coupon-item :status="1"
                          v-for="(item, index) in couponListObj[0]"
                          :item="item"
                          :key="index"></pi-coupon-item>
        </ul>
        <ul class="coupon-ul"
            v-if="form.couponStatus == 1">
          <pi-coupon-item :status="2"
                          v-for="(item, index) in couponListObj[1]"
                          :item="item"
                          :key="index"></pi-coupon-item>
        </ul>
        <ul class="coupon-ul"
            v-if="form.couponStatus == 2">
          <pi-coupon-item :status="3"
                          v-for="(item, index) in couponListObj[2]"
                          :item="item"
                          :key="index"></pi-coupon-item>
        </ul>
      </van-list>
    </div>
  </div>
</template>
<script>
import couponeItem from "./components/coupon-item";
import { getMyCoupon } from "@/common/api";
import { List } from "vant";
export default {
  name: "pi-my-coupon",
  components: {
    [couponeItem.name]: couponeItem,
    [List.name]: List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      active: 1,
      tabsList: [
        { label: "可使用", value: 0 },
        { label: "已使用", value: 1 },
        { label: "已过期", value: 2 },
      ],
      couponListObj: {
        0: [],
        1: [],
        2: [],
      },
      form: {
        accounPkId: "",
        couponStatus: 0,
        globalPageIndex: 0,
        globalPageSize: 10,
      },
    };
  },
  methods: {
    tabClick(val) {
      this.form.couponStatus = val;
      this.form.globalPageIndex = 0;
      this.couponListObj[this.form.couponStatus] = [];
      if(this.finished){
        this.finished = false;
      }else{
        this.form.globalPageIndex = 1;
        this.getMyCoupon();
      }
      
      // this.getMyCoupon();
      // console.log(val);
    },
    onLoad() {
      this.form.globalPageIndex++;
      this.getMyCoupon();
    },
    getMyCoupon() {

      getMyCoupon(this.form)
        .then((response) => {
          if (response.status == this.$config.ajaxStatus) {
            let list = response.data;
            this.couponListObj[this.form.couponStatus] = this.couponListObj[
              this.form.couponStatus
            ].concat(list);
            if (
              this.couponListObj[this.form.couponStatus].length >=
              response.total
            ) {
              this.finished = true;
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.finished = true;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.form.accounPkId = this.$route.query.accountPkId;
    // this.getMyCoupon();
  },
};
</script>
<style lang="less">
.pi-my-coupon {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #efeff4;
  .coupon-tabs {
    height: 0.96rem;
    background-color: #fff;
    display: flex;
    font-size: 0.34rem;
    line-height: 0.48rem;
    color: #666;
    .coupon-tabs-item {
      flex: 1;
      padding: 0.25rem 0;
      text-align: center;
    }
    .coupon-tabs-item.active {
      color: #14cc80;
      position: relative;
    }
    .coupon-tabs-item.active:after {
      content: "";
      width: 1.02rem;
      height: 0.04rem;
      background-color: #14cc80;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      position: absolute;
    }
  }
  .coupon-list {
    flex: 1;
    padding: 0.2rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .no-data {
    text-align: center;
    color: #999;
    padding: 0.5rem 0;
  }
}
</style>
